import { FormModel } from "components/Form";
import { Validators } from "utils/validators";

export const ForgotPasswordModalForm = (strings: any): FormModel[] => {
    return [
        {
            label: `${strings.newPasswordPlaceholderText}`,
            value: '',
            typeValue: 'password',
            type: 'text',
            placeholder: strings.enterPasswordPlaceholderText,
            field: 'password',
            variant: 'outlined',
            validators: [
                { check: Validators.required, message: strings.requiredField},
                { check: Validators.password, message: strings.required_password_msg }
              ],
            required: true,
            responsive: { xs: 12 },
            size: 'medium',
        },  
        {
            label: `${strings.confirmPasswordPlaceholderText}`,
            value: '',
            typeValue: 'password',
            type: 'text',
            placeholder: strings.reEnterPasswordPlaceholderText,
            field: 'confirmPassword',
            variant: 'outlined',
            validators: [
                { check: Validators.required, message: strings.requiredField},
                { check: Validators.password, message: strings.required_password_msg }
              ],
            required: true,
            responsive: { xs: 12 },
            size: 'medium',
        }, 
    ];
}
